import { memo } from 'react';
import { StyledSimpleCard } from 'styles';
import { TenantRegisterServiceForm } from 'TenantModule/components/Management/TenantRegisterServiceForm';
import { useTenantRegisterServiceForm } from 'TenantModule/hooks/useTenantRegisterServiceForm';

const RegisterServiceCard = () => {
  const formProps = useTenantRegisterServiceForm();

  return (
    <StyledSimpleCard>
      <h3>Register Service To Tenant</h3>
      <TenantRegisterServiceForm {...formProps} />
    </StyledSimpleCard>
  );
};

export default memo(RegisterServiceCard);
